<template>
  <section class="service-matrix">
    <div class="section-inner">
      <div class="section-header fade-in-section">
        <h2 class="section-title">{{ t('home.services.title') }}</h2>
        <p class="section-subtitle">{{ t('home.services.subtitle') }}</p>
      </div>

      <div class="service-grid">
        <article
          v-for="service in services"
          :key="service.key"
          class="service-card fade-in-section"
        >
          <div class="service-image-wrap">
            <img
              v-if="service.image"
              :src="service.image"
              :alt="t(`home.services.${service.key}.title`)"
              class="service-image"
            />
            <ImagePlaceholder
              v-else
              ratio="4:3"
              :label="t('home.services.imageLabel')"
              :keyword="t(`home.services.${service.key}.keyword`)"
            />
          </div>
          <div class="service-body">
            <h3 class="service-title">{{ t(`home.services.${service.key}.title`) }}</h3>
            <p class="service-description">{{ t(`home.services.${service.key}.description`) }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { useTranslation } from '@/utils/i18n'
import ImagePlaceholder from '@/components/ImagePlaceholder.vue'

export default {
  name: 'ServiceMatrix',
  components: {
    ImagePlaceholder
  },
  setup() {
    const { t } = useTranslation()

    const services = [
      {
        key: 'logistics',
        image: require('@/assets/img/home/service-logistics.png')
      },
      {
        key: 'freight',
        image: require('@/assets/img/home/service-freight.png')
      },
      {
        key: 'warehouse',
        image: require('@/assets/img/home/service-warehouse.png')
      },
      {
        key: 'blockchain',
        image: require('@/assets/img/home/service-blockchain.png')
      }
    ]

    return {
      t,
      services
    }
  }
}
</script>

<style lang="scss" scoped>
.service-matrix {
  padding: 96px 20px;
  background: #f7f9fc;
}

.section-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.section-header {
  max-width: 720px;
  margin: 0 auto 48px;
  text-align: center;
}

.section-title {
  margin: 0 0 16px;
  font-size: clamp(24px, 3vw, 32px);
  line-height: 1.25;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.section-subtitle {
  margin: 0;
  font-size: 16px;
  line-height: 1.7;
  color: #4a6075;
  font-family: 'Aileron-Regular', sans-serif;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
}

.service-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(11, 34, 56, 0.06);
}

.service-image-wrap {
  aspect-ratio: 4 / 3;
  overflow: hidden;
}

.service-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.service-body {
  padding: 24px;
}

.service-title {
  margin: 0 0 10px;
  font-size: 20px;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.service-description {
  margin: 0;
  font-size: 14px;
  line-height: 1.7;
  color: #52667a;
  font-family: 'Aileron-Regular', sans-serif;
}

@media (max-width: 1024px) {
  .service-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .service-grid {
    grid-template-columns: 1fr;
  }
}
</style>
